module.exports = __webpack_public_path__ + "img/tete_AA01.ac91b735.jpg";